import { __assign } from "tslib";
import { ATDealersLinks, ATGroupLinks } from '../footer-shared-links';
export var FooterCaravansLinks = function () {
    return [
        __assign({}, ATGroupLinks),
        {
            rowHeading: 'Services',
            subNav: [
                {
                    url: '/caravans/finance',
                    displayText: 'Caravan finance',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Private customers',
            subNav: [
                {
                    url: '/caravans/sell',
                    displayText: 'Sell my caravan',
                    routerLink: false,
                },
                {
                    url: '/caravans/sell-my-caravan/advertising-prices',
                    displayText: 'Advertising costs',
                    routerLink: false,
                },
                {
                    url: '/safety_and_security_centre',
                    displayText: 'Buying & selling safely online',
                    routerLink: false,
                },
                {
                    url: '/terms-and-conditions/advertising',
                    displayText: 'Terms & conditions',
                    routerLink: false,
                },
            ],
        },
        {
            rowHeading: 'Quick search',
            subNav: [
                {
                    url: '/caravans/used-caravans/browse-all-makes',
                    displayText: 'All caravans makes',
                    routerLink: false,
                },
                {
                    url: '/caravans/new-caravans',
                    displayText: 'New Caravans',
                    routerLink: false,
                },
                {
                    url: '/caravans/content',
                    displayText: 'Caravan reviews',
                    routerLink: false,
                },
                {
                    url: '/caravans/caravan-dealers',
                    displayText: 'Caravan dealers',
                    routerLink: false,
                },
            ],
        },
        __assign({}, ATDealersLinks),
    ];
};
export default FooterCaravansLinks;
